const adjustmentObjectToAdjustmentRequest = (object) => {
    return {
        adjustment_date: object.adjustmentDate,
        adjustment_status: object.adjustmentStatus,
        adjustment_type: object.adjustmentType,
        adjustment_amount: object.adjustmentAmount,
        final_amount: object.finalAmount,
        error_message: object.errorMessage,
    };
};

const adjustmentResponseToAdjustmentObject = (response) => {
    return {
        id: response.id,
        createdAt: response.created_at,
        adjustmentDate: response.adjustment_date,
        adjustmentStatus: response.adjustment_status,
        adjustmentType: response.adjustment_type,
        integrationId: response.integration_id,
        trackingNumber: response.tracking_number,
        externalOrderId: response.external_order_id,
        packageType: response.package_type,
        carrier: response.carrier,
        service: response.service,
        zone: response.zone,
        adjustmentAmount: response.adjustment_amount,
        finalAmount: response.final_amount,
        errorMessage: response.error_message,
    };
};

export { adjustmentResponseToAdjustmentObject, adjustmentObjectToAdjustmentRequest };
